import { Playground, Props } from 'docz';
import { SignInButton } from '@cosmotech/ui';
import img from "../../../../../../assets/microsoft_logo.png";
import * as React from 'react';
export default {
  Playground,
  Props,
  SignInButton,
  img,
  React
};